module.exports = __webpack_public_path__ + "img/06.7ad4fb04.jpg";